import { DeviceAssignments } from 'src/app/ui/shared/assign-device-controls/assign-device-controls.component';

export type DeviceControl = Components.Schemas.DeviceControl;
export type DeviceControlResponse = Components.Responses.DeviceControlResponse;

export type ControlAssignment = Components.Schemas.ControlAssignment;
export type ControlAssignmentOption =
	Components.Schemas.ControlAssignmentOption;
export type AssignableRelationshipType =
	Components.Schemas.AssignableRelationshipType;

export type ControlAssignmentAction =
	Components.Schemas.ControlAssignmentAction;

export const emptyDeviceControl = (): DeviceControl => ({
	id: '',
	name: '',
	companyId: '',
	days: {
		sunday: { value: false, disabled: false },
		monday: { value: false, disabled: false },
		tuesday: { value: false, disabled: false },
		wednesday: { value: false, disabled: false },
		thursday: { value: false, disabled: false },
		friday: { value: false, disabled: false },
		saturday: { value: false, disabled: false },
	},
	startTime: '',
	endTime: '',
	permissions: {
		canReleaseHasp: { value: false, disabled: false },
		canOpenKeyDoor: { value: false, disabled: false },
		canUpdateFirmware: { value: false, disabled: false },
		canInstallDevice: { value: false, disabled: false },
		canRemoveDevice: { value: false, disabled: false },
		canArmDisarmAjaxAlarm: { value: false, disabled: false },
		canOverrideAjaxAlarm: { value: false, disabled: false },
	},
	isUniversal: false,
	active: true,
	isOwner: true,
});

export const emptyDeviceAssignment = (): DeviceAssignments => ({
	allowCodeGeneration: { value: false, disabled: false },
	allowHaspCodeGeneration: { value: false, disabled: false },
});

export const emptyControlAssignmentOption = (
	type: AssignableRelationshipType
): ControlAssignmentOption => ({
	entityRelationshipId: '',
	relationshipType: type,
	displayName: '',
});

export enum AssignableRelationshipTypeEnum {
	company = 'company',
	user = 'user',
}

export const PDQ_KMS_GENERATION_1 = 'pdqkms1';
export const PDQ_SDS_GENERATION_1 = 'pdqsds1';

export const DEVICE_GENERATION_3 = 'gen3';
export const DEVICE_GENERATION_4 = 'gen4';
